import { z } from 'zod'

const requiredText = z.string({ required_error: 'Text input is required' })

export const adminDashboardFormSchema = z.object({
  image: z.any().optional(),
  boardName: requiredText,
  isActive: z.boolean().optional(),
})

export type AdminDashboardFormType = z.infer<typeof adminDashboardFormSchema>
